import { useState, useEffect } from 'react'

/**
 * Custom hook to track if the old analytics panel is open
 * @returns {boolean} isAnalyticsOpen - true if analytics panel is visible, false otherwise
 */
export function useIsOldAnalyticsOpen() {
    const [isAnalyticsOpen, setIsAnalyticsOpen] = useState(false)

    useEffect(() => {
        // The legacy #analytics panel only exists on EJS graph pages —
        // standalone React pages like /import/* have neither the element
        // nor a panel to track
        const analyticsPanel = document.getElementById('analytics')
        if (!analyticsPanel) return

        const initialState = analyticsPanel.checkVisibility()

        if (initialState) {
            setIsAnalyticsOpen(true)
        }

        // Listen for analytics panel toggle events
        if (window.myEventEmitter) {
            const handleAnalyticsToggle = () => {
                setTimeout(() => {
                    const panel = document.getElementById('analytics')
                    const isVisible = panel && panel.checkVisibility()
                    if (isVisible) {
                        setIsAnalyticsOpen(true)
                    } else {
                        setIsAnalyticsOpen(false)
                    }
                }, 350) // Wait for fade animation to complete
            }

            const handleAnalyticsAction = action => {
                if (action === 'toggle_analytics') {
                    handleAnalyticsToggle()
                }
            }

            myEventEmitter.on('onAnalyticsAction', handleAnalyticsAction)

            // Cleanup
            return () => {
                if (myEventEmitter._events['onAnalyticsAction']) {
                    myEventEmitter.removeListener(
                        'onAnalyticsAction',
                        handleAnalyticsAction
                    )
                }
            }
        }
    }, [])

    return isAnalyticsOpen
}

export default useIsOldAnalyticsOpen
